// Electron shell bridge. Present only when the POS runs inside the
// waio-windows-v2 desktop wrapper, which attaches a preload exposing
// window.waio with shell-only operations (open settings, etc.).
// Returns null in regular browsers and Capacitor builds.

type ElectronShell = {
  openSettings: () => Promise<void>
  getShellInfo: () => Promise<{ version: string; platform: string }>
}

export function getElectronShell(): ElectronShell | null {
  if (typeof window === 'undefined') return null
  const candidate = (window as unknown as { waio?: unknown }).waio
  if (
    candidate &&
    typeof candidate === 'object' &&
    typeof (candidate as { openSettings?: unknown }).openSettings === 'function'
  ) {
    return candidate as ElectronShell
  }
  return null
}
